(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faqs"] && !Shopify.designMode) return;
  try {
    
/*{
  "@context": "https://schema.org",
  "@type": "FAQPage",
  "mainEntity": [
    {
      "@type": "Question",
      "name": "When should I drink Godspeed?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Godspeed is designed for anytime clean energy and hydration. Most people use it in the morning to start the day strong, before a workout for endurance and focus, or in place of an afternoon crash instead of coffee or sugary energy drinks."
      }
    },
    {
      "@type": "Question",
      "name": "Do I have to be fasting to take Godspeed?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "No. While ketones are often associated with fasting, Godspeed works with or without food. Ketones provide an additional fuel source that pairs with carbs or fat, giving you true metabolic flexibility."
      }
    },
    {
      "@type": "Question",
      "name": "Does Godspeed contain sugar?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "No. Godspeed is zero sugar and free from artificial sweeteners. It uses organic monk fruit, organic stevia, and real organic lemon powder for clean, natural flavor."
      }
    },
    {
      "@type": "Question",
      "name": "What makes Godspeed different from other energy drinks?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Most energy drinks rely on sugar or synthetic caffeine. Godspeed combines clean electrolytes, BHB ketones, Enfinity® paraxanthine, theobromine, and nootropics for hydration, energy, and focus without the crash. It’s the first performance hydration + clean energy drink in one."
      }
    },
    {
      "@type": "Question",
      "name": "What are Enfinity® paraxanthine and theobromine?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Enfinity® paraxanthine is the clean metabolite of caffeine that delivers focus and alertness without jitters or crash. Theobromine, found in cacao, provides smooth energy, blood flow support, and mood lift. Together they create stable, crash-free energy."
      }
    },
    {
      "@type": "Question",
      "name": "Is Godspeed keto-friendly?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes. Godspeed contains no sugar and provides BHB ketones for fuel, making it fully keto- and low-carb friendly."
      }
    },
    {
      "@type": "Question",
      "name": "Is Godspeed safe?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes. All ingredients are clinically studied, GRAS (Generally Recognized as Safe), and made in the USA. Godspeed is crafted with organic sweeteners, real fruit powder, and functional ingredients only. As with any supplement, consult a physician if you are pregnant, nursing, or managing a medical condition."
      }
    },
    {
      "@type": "Question",
      "name": "What if I don’t like it?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "We stand by Godspeed with a 30-day money-back guarantee. Just email our support team and we’ll make it right."
      }
    },
    {
      "@type": "Question",
      "name": "Is Godspeed veteran-owned?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes. Godspeed is proudly made in America and veteran owned."
      }
    }
  ]
} */

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["review-the-label"] && !Shopify.designMode) return;
  try {
    
    document.getElementById("label-popup-open").onclick = function() {
      document.getElementById("label-popup").classList.toggle("open");
    };
    document.getElementById("label-popup-close").onclick = function() {
      document.getElementById("label-popup").classList.toggle("open");
    };
  
  } catch(e) { console.error(e); }
})();
})();
